module.exports = __webpack_public_path__ + "assets/img/ba6f-re.svg";